export default [
    {
        name: 'helpList',
        path: '/help/list',
        component: require('@/pages/HelpList').default,
        props: (route) => ({
            model: null,
            id: null,
        }),
        meta: {
            back: { label: 'Dashboard', to: '/' },
            security: (auth) => auth.can({ action: 'list', model: 'help' })
        }
    },
    {
        name: 'helpCreate',
        path: '/help/create',
        component: require('@/pages/HelpCreate').default,
        meta: {
            back: { label: 'Help Messages', to: '/help/list' },
            security: (auth) => auth.can({ action: 'create', model: 'help' })
        }
    },
    {
        name: 'helpView',
        path: '/help/view/:helpId',
        component: require('@/pages/HelpView').default,
        props: (route) => ({
            helpId: +route.params.helpId,
        }),
        meta: {
            back: { label: 'Help Messages', to: '/help/list' },
            security: (auth) => auth.can({ action: 'view', model: 'help' })
        }
    },
    {
        name: 'helpEdit',
        path: '/help/edit/:helpId',
        component: require('@/pages/HelpEdit').default,
        props: (route) => ({
            helpId: +route.params.helpId,
        }),
        meta: {
            back: { label: ':helpName', to: '/help/view/:helpId' },
            security: (auth) => auth.can({ action: 'edit', model: 'help' })
        }
    },
]
